/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Pka
 */
export interface Pka {
    /**
     * 
     * @type {number}
     * @memberof Pka
     */
    position: number;
    /**
     * 
     * @type {number}
     * @memberof Pka
     */
    wt: number;
    /**
     * 
     * @type {number}
     * @memberof Pka
     */
    mut: number;
    /**
     * 
     * @type {number}
     * @memberof Pka
     */
    diff: number;
}

/**
 * Check if a given object implements the Pka interface.
 */
export function instanceOfPka(value: object): value is Pka {
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('wt' in value) || value['wt'] === undefined) return false;
    if (!('mut' in value) || value['mut'] === undefined) return false;
    if (!('diff' in value) || value['diff'] === undefined) return false;
    return true;
}

export function PkaFromJSON(json: any): Pka {
    return PkaFromJSONTyped(json, false);
}

export function PkaFromJSONTyped(json: any, ignoreDiscriminator: boolean): Pka {
    if (json == null) {
        return json;
    }
    return {
        
        'position': json['position'],
        'wt': json['wt'],
        'mut': json['mut'],
        'diff': json['diff'],
    };
}

export function PkaToJSON(json: any): Pka {
    return PkaToJSONTyped(json, false);
}

export function PkaToJSONTyped(value?: Pka | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'position': value['position'],
        'wt': value['wt'],
        'mut': value['mut'],
        'diff': value['diff'],
    };
}

